import { onMounted, ref } from "vue";

/**
 * First-paint intro for a layout.
 *
 * Returns `intro`, which the layout binds to a class that runs the entrance
 * animation. It is false during SSR and switched on at mount, so the
 * server-rendered markup is never hidden by CSS the client might not get to
 * undo — a browser that errors before hydration, or never runs the script at
 * all, still sees a complete page. The animation itself carries its own start
 * state through `animation-fill-mode: both`, which is why nothing has to be
 * hidden up front.
 */
export function usePageIntro() {
  const intro = ref(false);

  onMounted(() => {
    if (
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }
    intro.value = true;
  });

  return { intro };
}
